export const server = "https://eshop-backend-application.onrender.com/api/v2"
